module.exports = __webpack_public_path__ + "media/images/iconRegist-9a86b356209d797098fb557b426b56bd.png";